import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

import type { Category, MenuItem, TagId, TagConfig } from 'src/types/types';
import { Heading } from 'src/components/Heading/Heading';
import { CardList } from 'src/components/CardList/CardList';
import { Container } from 'src/components/Container/Container';

import styles from './styles.module.scss';

type CategorySectionProps = {
  category: Category;
  items: MenuItem[];
  tagConfig: Record<TagId, TagConfig>;
  onInView?: (id: string, inView: boolean) => void;
  headingLevel?: 2 | 3;
  priorityCount?: number;
};

export const CategorySection = ({
  category,
  items,
  tagConfig,
  onInView,
  headingLevel = 2,
  priorityCount = 0,
}: CategorySectionProps) => {
  const { ref, inView } = useInView({
    rootMargin: '-110px 0px -75% 0px',
    threshold: 0,
  });

  useEffect(() => {
    onInView?.(category.id, inView);
  }, [inView, category.id, onInView]);

  return (
    <section id={category.id} ref={ref} className={styles.section}>
      <Container>
        <Heading level={headingLevel} className={styles.title}>
          {category.name}
        </Heading>
        <CardList
          items={items}
          tagConfig={tagConfig}
          priorityCount={priorityCount}
        />
      </Container>
    </section>
  );
};
